import { getAnalytics, logEvent } from 'firebase/analytics'
import { initializeApp } from 'firebase/app'

let analyticsInstance: ReturnType<typeof getAnalytics> | null = null

const getAnalyticsInstance = () => {
	if (analyticsInstance) {
		return analyticsInstance
	}

	const ALLOW_FIREBASE_FOR_DEV = false

	const isProduction = (
		ALLOW_FIREBASE_FOR_DEV ||
		window.location.hostname.includes('solvemate-ai.jetrr.app') ||
		window.location.hostname.includes('production.solvemate.jetrr.app')
	)

	if (!isProduction) {
		return null
	}

	try {
		const firebaseConfig = {
			apiKey: 'AIzaSyA2M7nimBhCHyqxErFb5jJWfa94Z0U1lww',
			authDomain: 'jetrr-vision.firebaseapp.com',
			projectId: 'jetrr-vision',
			storageBucket: 'jetrr-vision.appspot.com',
			messagingSenderId: '618181588714',
			appId: '1:618181588714:web:7bcfead8acec6017a48993',
			measurementId: 'G-M2YTDTH4KN',
		}

		const app = initializeApp(firebaseConfig, {
			name: 'solvemate-prod-web-analytics',
			automaticDataCollectionEnabled: true,
		})
		analyticsInstance = getAnalytics(app)
		return analyticsInstance
	} catch (error) {
		console.warn('Failed to initialize Firebase Analytics', error)
		return null
	}
}

const track = (eventName: string, eventParams?: Record<string, string | number | boolean>) => {
	const analytics = getAnalyticsInstance()
	if (!analytics) {
		return
	}

	try {
		logEvent(analytics, eventName, eventParams)
	} catch (error) {
		console.warn(`Failed to log analytics event: ${eventName}`, error)
	}
}

export const analytics = {
	// Activation events
	onboardingStarted: () => {
		track('onboarding_started')
	},
	onboardingCompleted: () => {
		track('onboarding_completed')
	},
	firstMessageSent: () => {
		track('first_message_sent')
	},
	firstImageScanned: () => {
		track('first_image_scanned')
	},

	// Engagement events
	chatMessageSent: (messageNumber: number, hasImage: boolean) => {
		track('chat_message_sent', {
			message_number: messageNumber,
			has_image: hasImage,
		})
	},
	chatResponseReceived: () => {
		track('chat_response_received')
	},
	videoRecommendationRequested: () => {
		track('video_recommendation_requested')
	},
	videoWatched: (videoTitle?: string) => {
		track('video_watched', {
			video_title: videoTitle || 'unknown',
		})
	},
	videoSaved: (videoTitle?: string) => {
		track('video_saved', {
			video_title: videoTitle || 'unknown',
		})
	},
	messageStarred: () => {
		track('message_starred')
	},
	quizStarted: () => {
		track('quiz_started')
	},
	followUpClicked: () => {
		track('follow_up_clicked')
	},

	// Retention events
	sessionStarted: (returningUser: boolean) => {
		track('session_started', {
			returning_user: returningUser,
		})
	},
	sessionHeartbeat: () => {
		track('session_heartbeat')
	},

	// Conversion events
	paywallShown: () => {
		track('paywall_shown')
	},
	paywallDismissed: () => {
		track('paywall_dismissed')
	},
	quotaWarningShown: (messagesLeft: number) => {
		track('quota_warning_shown', {
			messages_left: messagesLeft,
		})
	},
	freeMessagesExhausted: () => {
		track('free_messages_exhausted')
	},

	// Sharing events
	answerShared: (method: 'native' | 'web_share' | 'clipboard') => {
		track('answer_shared', {
			method: method,
		})
	},
}
